import type { Questionnaire } from '../types';

export const QUESTIONNAIRES_SEED: ReadonlyArray<Questionnaire> = [
  {
    id: '1001',
    name: 'Post Stay Questionnaire',
    title: 'Guest Feedback Questionnaire',
    type: 'post-stay',
    status: 'active',
    isDefault: true,
    pageCount: 17,
    createdAtIso: '2014-05-21T14:35:24.000Z',
  },
  {
    id: '1011',
    name: 'Pre Stay Questionnaire (Test)',
    title: 'Default Pre Stay Test',
    type: 'pre-stay',
    status: 'draft',
    isDefault: false,
    pageCount: 3,
    createdAtIso: '2018-04-09T14:02:47.000Z',
  },
  {
    id: '1024',
    name: 'The Langdon Post Stay',
    title: 'Gareth Test',
    type: 'post-stay',
    status: 'active',
    isDefault: false,
    pageCount: 15,
    createdAtIso: '2019-11-02T09:12:00.000Z',
  },
  {
    id: '1030',
    name: 'In-Stay Pulse Check',
    title: 'Mid-Stay Experience',
    type: 'in-stay',
    status: 'active',
    isDefault: false,
    pageCount: 6,
    createdAtIso: '2021-02-18T11:44:10.000Z',
  },
  {
    id: '1042',
    name: 'Cancellation Feedback',
    title: 'Why did you cancel?',
    type: 'cancellation',
    status: 'inactive',
    isDefault: false,
    pageCount: 4,
    createdAtIso: '2021-08-30T16:05:41.000Z',
  },
  {
    id: '1055',
    name: 'Conference & Events Survey',
    title: 'Events Feedback',
    type: 'custom',
    status: 'active',
    isDefault: false,
    pageCount: 11,
    createdAtIso: '2022-03-14T08:20:00.000Z',
  },
  {
    id: '1063',
    name: 'Spa Experience Questionnaire',
    title: 'Wellness Feedback',
    type: 'post-stay',
    status: 'inactive',
    isDefault: false,
    pageCount: 8,
    createdAtIso: '2022-09-01T13:50:33.000Z',
  },
  {
    id: '1078',
    name: 'Pre-Arrival Preferences',
    title: 'Tell us before you arrive',
    type: 'pre-stay',
    status: 'active',
    isDefault: false,
    pageCount: 5,
    createdAtIso: '2023-01-25T10:15:12.000Z',
  },
  {
    id: '1090',
    name: 'Loyalty Member Survey',
    title: 'Rewards Feedback',
    type: 'custom',
    status: 'draft',
    isDefault: false,
    pageCount: 9,
    createdAtIso: '2023-06-11T15:30:47.000Z',
  },
  {
    id: '1104',
    name: 'Restaurant Dining Feedback',
    title: 'How was your meal?',
    type: 'in-stay',
    status: 'active',
    isDefault: false,
    pageCount: 7,
    createdAtIso: '2024-02-07T12:00:00.000Z',
  },
  {
    id: '1119',
    name: 'Corporate Traveller Survey',
    title: 'Business Stay Feedback',
    type: 'post-stay',
    status: 'active',
    isDefault: false,
    pageCount: 13,
    createdAtIso: '2024-10-19T07:41:55.000Z',
  },
  {
    id: '1127',
    name: 'Winter Season Feedback',
    title: 'Seasonal Guest Survey',
    type: 'custom',
    status: 'inactive',
    isDefault: false,
    pageCount: 6,
    createdAtIso: '2025-04-03T18:22:09.000Z',
  },
];
